// A summary of refunds for the last period
import React from "react";
import WhiteBox from "../../Styled/WhiteBox";

export default function ThirtyDayRefunds() {
  return <WhiteBox>Last 30 days</WhiteBox>;
}
